import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';
import AssessmentReport from './AssessmentReport';

export default [AnswerSummary, AssessmentReport];
